import React, { createContext, useContext, useReducer, useEffect } from "react";

import {
  getConfigurationRole,
  getNecessaryRoles,
} from "helper/CommonFunctions";
import { selectFactoryRoles } from "helper/FactoryRoles";
import { useState } from "react";
import {
  COMPANY_ID,
  FACTORY_ID,
  USER_ID,
  LANG_KEY,
  ASSEMBLYLINE_ID,
  MILLINGLINE_ID,
  BOILER_ID,
  DISTILLERY_BOILER_ID,
} from "constants/AuthConstant";
import { onLocaleChange } from "store/slices/themeSlice";
import i18n, { getLangResources } from "lang";
import { API_BASE_URL } from "configs/AppConfig";
import { getValidToken } from "auth/TokenRefresh";
import { useDispatch } from "react-redux";
import { signOut } from "store/slices/authSlice";
import { useLocation } from "react-router-dom";
import {
  BOILERS_PATHS,
  COMMON_BH_SECTIONS_PATHS,
  COMMON_DB_SECTIONS_PATHS,
  DISTILLERY_BOILER_PATHS,
  EMPTY_GUID,
} from "constants/AppConstant";

export const UserDataContext = createContext();

const initialState = {
  companies: [],
  factories: [],
  assemblyLines: [],
  boilers: [],
  distilleryBoilers: [],
  newRoles: [],
  factoryRoles: [],
  houseImages: [],
  userPermissions: [],
  unreadNotifications: 0,
  notificationsVersion: 0,
  lang_Key: null,
  factoryNotifications: [],
  users: [],
  subAssemblyDetail: {
    assemblyId: null,
    subAssemblyId: null,
    assemSubAssemblyId: null,
    viaDashboard: false,
  },
  companyId: null,
  factoryId: null,
  assemblyLineId: null,
  millingLineId: null,
  boilerId: null,
  distilleryBoilerId: null,
  isLoading: false,
  isGreenFuel: false,
  comapniesForDepModule: [],
  showDepModule: false,
};
const userReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_PERMISSIONS":
      return {
        ...state,
        users: action.payload.users,
        newRoles: action.payload.newRoles,
        userPermissions: action.payload.usersPermission,
      };
    case "UPDATE_COMPANY_FACTORY_LIST":
      return {
        ...state,
        companies: action.payload.companies,
        factories: action.payload.factories,
        assemblyLines: action.payload.assemblyLines,
        boilers: action.payload.boilers,
        distilleryBoilers: action.payload.distilleryBoilers,
      };
    case "UPDATE_COMPANY":
      return {
        ...state,
        companyId: action.payload.companyId,
        isGreenFuel: action.payload.isGreenFuel,
        showDepModule: action.payload.showDepModule,
        comapniesForDepModule: action.payload.comapniesForDepModule,
      };
    case "UPDATE_FACTORY":
      return { ...state, factoryId: action.payload };
    case "UPDATE_ASSEMBLYLINE": // this is parameter that will be use for Milling Line Id, Boiler Id, Distillery Boiler Id;
      return { ...state, assemblyLineId: action.payload };
    case "UPDATE_MILLINGLINE":
      return { ...state, millingLineId: action.payload };
    case "UPDATE_BOILER":
      return { ...state, boilerId: action.payload };
    case "UPDATE_DISTILLERY_BOILER":
      return { ...state, distilleryBoilerId: action.payload };
    case "UPDATE_FACTORY_ROLES":
      return { ...state, factoryRoles: action.payload };
    case "UPDATE_HOUSE_IMAGES":
      return { ...state, houseImages: action.payload };
    case "UPDATE_SUBASSEMBLY_DETAILS":
      return { ...state, subAssemblyDetail: action.payload };
    case "UPDATE_UNREAD_NOTIFICATIONS":
      return { ...state, unreadNotifications: action.payload };
    case "REFRESH_NOTIFICATIONS":
      return { ...state, notificationsVersion: state.notificationsVersion + 1 };
    case "UPDATE_LANGUAGE":
      return { ...state, lang_Key: action.payload };
    case "UPDATE_LOADING":
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
};
export const updateUserPermissions = (dispatch, userPermissions) => {
  dispatch({
    type: "UPDATE_PERMISSIONS",
    payload: userPermissions,
  });
};
export const setCompanyId = (dispatch, data) => {
  dispatch({
    type: "UPDATE_COMPANY",
    payload: data,
  });
  localStorage.setItem(COMPANY_ID, data.companyId);
  localStorage.removeItem(FACTORY_ID);
};
export const setLanguage = (dispatch, langkey) => {
  dispatch({
    type: "UPDATE_LANGUAGE",
    payload: langkey,
  });
  localStorage.setItem(LANG_KEY, langkey);
};
export const setSubAssemblyDetail = (dispatch, subAssemblyDetail) => {
  dispatch({
    type: "UPDATE_SUBASSEMBLY_DETAILS",
    payload: subAssemblyDetail,
  });
};
export const setCompanyFactories = (dispatch, data) => {
  dispatch({
    type: "UPDATE_COMPANY_FACTORY_LIST",
    payload: data,
  });
};
export const setFactoryId = (dispatch, factoryId) => {
  dispatch({
    type: "UPDATE_FACTORY",
    payload: factoryId,
  });
  localStorage.setItem(FACTORY_ID, factoryId);
};
export const setAssemblyLineId = (dispatch, assemblyLineId) => {
  dispatch({
    type: "UPDATE_ASSEMBLYLINE",
    payload: assemblyLineId,
  });
  localStorage.setItem(ASSEMBLYLINE_ID, assemblyLineId);
};
export const setMillingLineId = (dispatch, millingLineId) => {
  dispatch({
    type: "UPDATE_MILLINGLINE",
    payload: millingLineId,
  });
  localStorage.setItem(MILLINGLINE_ID, millingLineId);
};
export const setBoilerId = (dispatch, boilerId) => {
  dispatch({
    type: "UPDATE_BOILER",
    payload: boilerId,
  });
  localStorage.setItem(BOILER_ID, boilerId);
};
export const setDistilleryBoilerId = (dispatch, boilerId) => {
  dispatch({
    type: "UPDATE_DISTILLERY_BOILER",
    payload: boilerId,
  });
  localStorage.setItem(DISTILLERY_BOILER_ID, boilerId);
};
export const setFactoryRoles = (dispatch, factoryRoles) => {
  dispatch({
    type: "UPDATE_FACTORY_ROLES",
    payload: factoryRoles,
  });
};
export const setHouseImages = (dispatch, houseImages) => {
  dispatch({
    type: "UPDATE_HOUSE_IMAGES",
    payload: houseImages,
  });
};
export const setLoading = (dispatch, isLoading) => {
  dispatch({
    type: "UPDATE_LOADING",
    payload: isLoading,
  });
};
export const setUnreadNotifications = (dispatch, count) => {
  dispatch({
    type: "UPDATE_UNREAD_NOTIFICATIONS",
    payload: count,
  });
};
export function UserDataProvider({ children }) {
  const [userData, dispatch] = useReducer(userReducer, initialState);
  const [error, setError] = useState(null);
  const dispatch_ = useDispatch();
  const location = useLocation();
  const updateUserPermissionsWithContext = (userPermissions) => {
    updateUserPermissions(dispatch, userPermissions);
  };
  const setCompanyFactoriesWithContext = (data) => {
    setCompanyFactories(dispatch, data);
  };
  const setCompanyIdWithContext = (data) => {
    setCompanyId(dispatch, data);
  };
  const setLanguageWithContext = (langkey) => {
    setLanguage(dispatch, langkey);
  };
  const setFactoryIdWithContext = (factoryId) => {
    setFactoryId(dispatch, factoryId);
  };
  const setAssemblyLineIdWithContext = (assemblyLineId) => {
    setAssemblyLineId(dispatch, assemblyLineId);
  };
  const setMillingLineIdWithContext = (millingLineId) => {
    setMillingLineId(dispatch, millingLineId);
  };
  const setBoilerIdWithContext = (boilerId) => {
    setBoilerId(dispatch, boilerId);
  };
  const setDistilleryBoilerIdWithContext = (boilerId) => {
    setDistilleryBoilerId(dispatch, boilerId);
  };
  const setFactoryRolesWithContext = (factoryRoles) => {
    setFactoryRoles(dispatch, factoryRoles);
  };
  const setHouseImagesWithContext = (houseImages) => {
    setHouseImages(dispatch, houseImages);
  };
  const setSubAssemblyDetailWithContext = (subAssemblyDetails) => {
    setSubAssemblyDetail(dispatch, subAssemblyDetails);
  };
  const setUnreadNotificationsWithContext = (count) => {
    setUnreadNotifications(dispatch, count);
  };
  const refreshNotificationsWithContext = () => {
    dispatch({ type: "REFRESH_NOTIFICATIONS" });
  };
  const setLoadingWithContext = (isLoading) => {
    setLoading(dispatch, isLoading);
  };
  const userId = localStorage.getItem(USER_ID);
  useEffect(() => {
    const fetchData = async (token) => {
      try {
        if (userId) {
          const response = await fetch(
            `${API_BASE_URL}/UserManagement/FetchUser?userId=${userId}`,
            {
              method: "GET",
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.ok) {
            const data = await response.json();
            dispatch({ type: "UPDATE_PERMISSIONS", payload: data });
            if (data.companies && data.factories) {
              const selectedCompanyId = localStorage.getItem(COMPANY_ID);
              const selectedFactoryId = localStorage.getItem(FACTORY_ID);
              const selectedAssemblyLineId =
                localStorage.getItem(ASSEMBLYLINE_ID);
              const selectedMillingLineId =
                localStorage.getItem(MILLINGLINE_ID);
              const selectedBoilerId = localStorage.getItem(BOILER_ID);
              const selectedDistilleryBoilerId =
                localStorage.getItem(DISTILLERY_BOILER_ID);
              const langKey = localStorage.getItem(LANG_KEY);
              const langKey_ = langKey || data.users[0].lang_Key;

              const companyId_ =
                selectedCompanyId ||
                (data.companies.length > 0 && data.companies[0].companyId);
              const isGreenFuel_ =
                companyId_ && data.companies.length > 0
                  ? data.companies
                      .find((x) => x.companyId == companyId_)
                      .companyName.toLowerCase()
                      .includes("green fuel")
                  : false;
              const factoryId_ =
                selectedFactoryId ||
                (data.companies.length > 0 &&
                  data.factories.find(
                    (x) => x.companyId === data.companies[0].companyId
                  )?.factoryRegisterationId);
              const assemblyLineId_ =
                selectedAssemblyLineId == selectedMillingLineId
                  ? selectedAssemblyLineId
                  : BOILERS_PATHS.includes(location.pathname)
                  ? selectedBoilerId
                  : DISTILLERY_BOILER_PATHS.includes(location.pathname)
                  ? selectedDistilleryBoilerId
                  : EMPTY_GUID;
              const millingLineId_ =
                selectedMillingLineId ||
                data.assemblyLines.filter((x) => x.factoryId == factoryId_)[0]
                  .assemblyLineId;
              const boilerId_ =
                selectedBoilerId ||
                data.boilers.filter((x) => x.factoryId == factoryId_)[0]
                  .boilerId;
              const distilleryBoilerId_ =
                selectedDistilleryBoilerId ||
                data.distilleryBoilers.filter(
                  (x) => x.factoryId == factoryId_
                )[0].distilleryBoilerId;
              const factoryRoles = selectFactoryRoles(
                data.newRoles,
                companyId_,
                factoryId_,
                langKey_
              );
              dispatch(onLocaleChange(langKey_));
              i18n.changeLanguage(langKey_);

              if (data.users[0].email === "super@admin.com") {
                if (factoryRoles.length <= 1) {
                  factoryRoles.push(...getNecessaryRoles(i18n, langKey_));
                }
                factoryRoles.push(...getConfigurationRole(i18n, langKey_));
              }
              const houseImages = data.houseMapping;
              dispatch({
                type: "UPDATE_COMPANY_FACTORY_LIST",
                payload: data,
              });
              dispatch({
                type: "UPDATE_COMPANY",
                payload: {
                  companyId: companyId_,
                  isGreenFuel: isGreenFuel_,
                  showDepModule: data.companiesToShowDepartmentModule.some(
                    (x) => x == companyId_
                  ),
                  comapniesForDepModule: data.companiesToShowDepartmentModule,
                },
              });
              dispatch({
                type: "UPDATE_FACTORY",
                payload: factoryId_,
              });
              dispatch({
                type: "UPDATE_ASSEMBLYLINE",
                payload: assemblyLineId_,
              });
              dispatch({
                type: "UPDATE_MILLINGLINE",
                payload: millingLineId_,
              });
              dispatch({
                type: "UPDATE_BOILER",
                payload: boilerId_,
              });
              dispatch({
                type: "UPDATE_DISTILLERY_BOILER",
                payload: distilleryBoilerId_,
              });
              dispatch({
                type: "UPDATE_LANGUAGE",
                payload: langKey_,
              });
              dispatch({
                type: "UPDATE_FACTORY_ROLES",
                payload: factoryRoles,
              });
              dispatch({
                type: "UPDATE_HOUSE_IMAGES",
                payload: houseImages,
              });
            }
          } else if (response.status == "401") {
            dispatch_(signOut());
          }
        }
      } catch (error) {
        console.error("Error:", error);
        setError(error);
      } finally {
        //setLoading(false);
      }
    };
    getValidToken().then((validToken) => {
      if (validToken) {
        fetchData(validToken);
      } else {
        dispatch_(signOut());
      }
    });
  }, []);

  return (
    <UserDataContext.Provider
      value={{
        ...userData,
        updateUserPermissions: updateUserPermissionsWithContext,
        setCompanyFactories: setCompanyFactoriesWithContext,
        setCompanyId: setCompanyIdWithContext,
        setLanguage: setLanguageWithContext,
        setFactoryId: setFactoryIdWithContext,
        setAssemblyLineId: setAssemblyLineIdWithContext,
        setMillingLineId: setMillingLineIdWithContext,
        setBoilerId: setBoilerIdWithContext,
        setDistilleryBoilerId: setDistilleryBoilerIdWithContext,
        setFactoryRoles: setFactoryRolesWithContext,
        setHouseImages: setHouseImagesWithContext,
        setSubAssemblyDetail: setSubAssemblyDetailWithContext,
        setUnreadNotifications: setUnreadNotificationsWithContext,
        refreshNotifications: refreshNotificationsWithContext,
        setLoading: setLoadingWithContext,
      }}
    >
      {children}
    </UserDataContext.Provider>
  );
}
export function useUserData() {
  const context = useContext(UserDataContext);
  if (!context) {
    throw Error("useUserData must be used within a UserDataProvider");
  }
  return context;
}
//Function to get permissions for screen by passing screen path and userData;
export const getScreenPermission = (userData, path) => {
  const { companyId, factoryId, newRoles, userPermissions, users } = userData;
  var permissions = null;
  if (isSuperAdmin(userData) || isUserTypeSuperAdmin(userData)) {
    permissions = {
      canAdd: true,
      canEdit: true,
      canDelete: true,
      canView: true,
    };
  } else {
    const roleId = newRoles.find(
      (x) =>
        x.path == path && x.companyId == companyId && x.factoryId == factoryId
    )?.roleId;
    if (roleId == undefined) {
      permissions = {
        canAdd: false,
        canEdit: false,
        canDelete: false,
        canView: false,
      };
    } else {
      permissions = userPermissions.find((x) => x.roleId == roleId);
      permissions = permissions
        ? permissions
        : {
            canAdd: false,
            canEdit: false,
            canDelete: false,
            canView: false,
          };
    }
  }
  return permissions;
};

export const isSuperAdmin = (userData) => {
  return userData.users[0].email == "super@admin.com";
};
export const isUserTypeSuperAdmin = (userData) => {
  return userData.users[0].userTypeName.toLowerCase() == "super admin";
};
